<template lang="pug">
.content-wrapper(v-if="currentUser.rights.callsList == true")
  .table-header.d-flex.pb-2.justify-content-between
    h2.m-0 Список звонков
  .clients-table.text-center.small
    .d-flex.mb-2.justify-content-between
      select.form-control.col-2(v-model="selectedResult" v-on:change="getFiltredCalls")
        option(value="" disabled selected) Выберите результат
        option(value="") Все
        option(v-for="result in results" v-bind:key="result.id" v-bind:value="result.id") {{result.name}}
      select.form-control.col-2(v-model="selectedProject" v-on:change="getFiltredCalls")
        option(value="" disabled selected) Выберите проект
        option(value="") Все
        option(v-for="project in projects" v-bind:key="project.id" v-bind:value="project.id") {{project.name}}
      select.form-control.col-2(v-model="selectedOperator" v-on:change="getFiltredCalls")
        option(value="" disabled selected) Выберите оператора
        option(value="") Все
        option(v-for="operator in operators" v-bind:key="operator.id" v-bind:value="operator.id") {{operator.name}}
      date-range-picker(v-bind:locale-data="picker.locale" v-bind:opens="picker.opens" v-model="picker.dateRange" v-on:update="dateSelected()")
        div(slot="input" slot-scope="picker" v-on:click="isDataSelected=true")
          i.far.fa-calendar-check
      input.form-control.col-5(type="text" v-model="searchQuery" placeholder="Search")
    table.table.table-hover
      thead
        tr
          th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
            span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
      tbody
        tr(v-for="row in callsList" v-bind:key="row.id" v-on:click="showModal(row.id)")
          td(v-for="td in columnsHeader" v-bind:key="td.id") {{ row[td.key] }}
            span(v-if="td.key === 'operator_name'") {{row[td.operator_id]}}
    span(v-if='isMoreCalls' class="btn btn-info col-2 mt-2" v-on:click="getMoreCalls") Добавить звонки
  modal(v-show="isModalVisible" v-on:close="closeModal")
    template(v-slot:header="")
      h2 Информация о звонке
    template(v-slot:body="")
      .d-flex.justify-content-center.mb-5
        p(v-if="!!callData.record") Нет записи
        audio(v-else class="align-self-center" controls="controls" preload="none")
          source(v-bind:src="callData.record" type="audio/mpeg")
      .d-flex.justify-content-center.flex-wrap
        h3.text-center Данные заполненные оператором
        .d-flex.col-10.p-0.border-top.pt-2.justify-content-between
          .col-6.p-0 ФИО
          .col-6.p-0.text-right {{ mainFields.name }}
        .d-flex.col-10.p-0.border-top.pt-2.justify-content-between
          .col-6.p-0 Контактный телефон
          .col-6.p-0.text-right {{ mainFields.phone }}
        .d-flex.col-10.p-0.border-top.pt-2.justify-content-between
          .col-6.p-0 Сообщение
          .col-6.p-0.text-right {{ mainFields.message }}
        .d-flex.col-10.p-0.border-top.pt-2.justify-content-between(v-for="field in fields" v-bind:key="field.id")
          .col-6.p-0 {{ field.label }}
          .col-6.p-0.text-right {{ field.name === 'need_recall_by_time' ? getFormattedDatetime(field.value) : field.value }}
        h3.text-center Технические данные
        .d-flex.col-10.p-0.border-top.pt-2.justify-content-between(v-for="callField in callsInfoStruct" v-bind:key="callField.key")
          .col-6.p-0 {{ callField.title }}
          .col-6.p-0.text-right(v-if="callField.type == 'time'") {{ seconds2time(callData[callField.key]) }}
          .col-6.p-0.text-right(v-else-if="callField.type == 'select'") {{ callField.values[callData[callField.key]] }}
          .col-6.p-0.text-right(v-else-if="callData[callField.key] != ''") {{ callData[callField.key] }}

    template(v-slot:footer="")
      .form-group.d-flex.justify-content-end.col-12
        button.btn.btn-secondary.col-2(type="submit" v-on:click="closeModal") Закрыть
.alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
  <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
  button.close(type="button" data-dismiss="alert" aria-label="Close")
    span(aria-hidden="true") &times;
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
export default {
  components: { DateRangePicker },
  data: function () { /* eslint-disable */
    var columnsHeader = [
          {title: 'ID звонка', key: 'id'},
          {title: 'Проект', key: 'project_name'},
          {title: 'Оператор', key: 'operator_name'},
          {title: 'Дата звонка', key: 'calldate'},
          {title: 'Длительность', key: 'duration'},
          {title: 'Ожидание', key: 'waiting'},
          {title: 'Разговор', key: 'speaking'},
          {title: 'Постпроцессинг', key: 'postprocessing'},
          {title: 'Результат', key: 'result_name'}
          ]
    const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      isModalVisible: false,
      date: null,
      sortKey: '',
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      callsList: [],
      callData: [],
      mainFields: [],
      fields: [],
      isMoreCalls: true,
      page: 0,
      results: [],
      searchQuery: '',
      selectedResult: '',
      selectedProject: '',
      selectedOperator: '',
      projects: [],
      operators: [],
      isDataSelected: false,
      callsInfoStruct: [
        {title: 'ID звонка', key: 'id', type: ''},
        {title: 'ID звонка в сервисе "Море Звонков"', key: 'mz_id', type: ''},
        {title: 'Телефон, с которого звонили', key: 'src_number', type: ''},
        {title: 'Телефон, на который звонили', key: 'dst_number', type:''},
        {title: 'Дата звонка', key: 'calldate', type: ''},
        {title: 'Длительность', key: 'duration', type: 'time'},
        {title: 'Время ожидания ответа', key: 'waiting', type: 'time'},
        {title: 'Время разговора оператора', key: 'speaking', type: 'time'},
        {title: 'Время постобработки', key: 'postprocessing', type: 'time'},
        {title: 'Тарифицируемая длительность', key: 'billing_duration', type: 'time'},
        {title: 'Перевод на номер', key: 'transfer', type: 'time'},
        {title: 'Направление', key: 'direction', type: 'select', values: {0: 'Входящий', 1: 'Исходящий'}},
        {title: 'Проект', key: 'project_name', type: ''},
        {title: 'Оператор', key: 'operator_name', type: ''},
        {title: 'Результат разговора', key: 'result_name', type: ''}
      ],
      picker: {
        dateRange: {
          startDate: moment().subtract(6, 'days').startOf('day'),//.format(FORMAT),
          endDate: moment().endOf('day')//.format(FORMAT)
        },
        // startDate: '2017-09-05',
        // endDate: '2017-09-15',
        opens: "center",// which way the picker opens, default "center", can be "left"/"right"
        locale: {
          direction: 'ltr', // direction of text
          // format: 'DD-MM-YYYY', // fomart of the dates displayed
          separator: ' - ', // separator between the two ranges
          applyLabel: 'ОК',
          cancelLabel: 'Отмена',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: moment.weekdaysMin(), // array of days - see moment documenations for details
          monthNames: moment.monthsShort(), // array of month names - see moment documenations for details
          firstDay: 1,  // ISO first day of week - see moment documenations for details
          showWeekNumbers: true // show week numbers on each row of the calendar
        },
        ranges: { // default value for ranges object (if you set this to false ranges will no be rendered)
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'This month': [moment().startOf('month'), moment().endOf('month')],
          'This year': [moment().startOf('year'), moment().endOf('year')],
          'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
          'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    errorMessage () {
      if (!this.date) return 'Date is required.'
      return ''
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    },
    startPeriod: function () {
      if (this.isDataSelected) {
        const FORMAT = 'YYYY-MM-DD'
        return this.picker.dateRange.startDate//.format(FORMAT)
      }
      return '';
    },
    endPeriod: function () {
      if (this.isDataSelected) {
        const FORMAT = 'YYYY-MM-DD'
        return this.picker.dateRange.endDate//.format(FORMAT)
      }
      return '';
    },
  },
  methods: {
    seconds2time: function (seconds) {
      var hours = Math.floor(seconds / 3600)
      var minutes = Math.floor((seconds - (hours * 3600)) / 60)
      seconds = seconds - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = '0:' + seconds
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (callID) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getCallInfoFields&call_id=' + callID)
        .then(response => {
          this.mainFields = response.data.mainFields
          this.fields = response.data.fields
          this.callData = this.callsList.find(item => item.id == callID)
          this.isModalVisible = true
        })
    },
    getFiltredCalls () {
      this.page = 0
      this.getMoreCalls()
    },
    getMoreCalls () {
      var p = {
        action: 'getCallsForTable',
        page: this.page,
        only_done : 1,
        only_answered : 0,
        order : 'id',
        order_dir : 'DESC',
        project_id : this.selectedProject,
        result_id :this.selectedResult,
        operator_id : this.selectedOperator,
        start_date: this.startPeriod, // 2020-02-25
        end_date : this.endPeriod,
        search : ''
      }
      var ctx = this
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(response => {
          if (ctx.page == 0) {
            ctx.callsList = response.data.calls
          } else {
            ctx.callsList = ctx.callsList.concat(response.data.calls)
          }
          if (response.data.calls.length < 20) { ctx.isMoreCalls = false }
          ctx.page++
        })
      return this.callsList;
    },
    closeModal () {
      this.isModalVisible = false
    },
    dateSelected(e) {
      // console.log(this.appointment.appointmet_date);
      var ctx = this
      this.$nextTick(() => this.getFiltredCalls())
    },
    getFormattedDatetime(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('YYYY-MM-DD HH:mm')
    }
  },
  mounted () {
    this.getMoreCalls()
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getCallReults')
      .then(response => (this.results = response.data.results))
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProjectsList&client_id=' + this.client_id)
      .then(response => {
        this.projects = response.data.projects
        // console.log(this.projects)
      })
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getUsersList&client_id=' + this.client_id)
      .then(response => (this.operators = response.data.users))

  }
}
</script>



// WEBPACK FOOTER //
// src/components/callslist.vue